import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

var menus = localStorage.getItem('menu');
if (menus?.indexOf('FullState') == -1) {
  localStorage.clear();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
